module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sale":" Sale","shopAll":"Shop All {name}","newIn":"New In"},"ar":{"sale":"العروض","shopAll":"شاهد جميع {name}","newIn":"جديد"}}')
  delete Component.options._Ctor
}
